import { IFilter } from 'interfaces/filter-interfaces';
import { useEffect } from 'react';
import { IRootDispatch } from 'stores/rematch/root-store';
import { FilterType } from 'utilities/enum-utils';
import { useDispatch } from 'react-redux';

export function useInitialiseFilterMenuData(filter: IFilter, onChangeIsSearching: (searching: boolean) => void) {
  const { customersStore, teamStore } = useDispatch<IRootDispatch>();
  const { doGetCustomersLite, doFetchSupportCoordinators, doFetchCaseManagers } = customersStore;
  const { doFetchWorkerList } = teamStore;

  useEffect(() => {
    switch (filter.filter) {
      case FilterType.CUSTOMER: {
        (async () => {
          try {
            onChangeIsSearching(true);
            await doGetCustomersLite({ sortByRelevance: true, page: 1, pageSize: 10, pageTimestamp: new Date() });
          } finally {
            onChangeIsSearching(false);
          }
        })();
        break;
      }

      case FilterType.SUPPORT_COORDINATOR: {
        (async () => {
          try {
            onChangeIsSearching(true);
            await doFetchSupportCoordinators({ page: 1, pageSize: 10, pageTimestamp: new Date() });
          } finally {
            onChangeIsSearching(false);
          }
        })();
        break;
      }

      case FilterType.WORKER: {
        (async () => {
          try {
            onChangeIsSearching(true);
            await doFetchWorkerList({ page: 1, pageSize: 10, pageTimestamp: new Date() });
          } finally {
            onChangeIsSearching(false);
          }
        })();
        break;
      }

      case FilterType.CASE_MANAGER: {
        (async () => {
          try {
            onChangeIsSearching(true);
            await doFetchCaseManagers({ page: 1, pageSize: 10, pageTimestamp: new Date() });
          } finally {
            onChangeIsSearching(false);
          }
        })();
        break;
      }
    }
  }, [
    doGetCustomersLite,
    doFetchSupportCoordinators,
    doFetchCaseManagers,
    doFetchWorkerList,
    filter.filter,
    onChangeIsSearching,
  ]);
}
